import { deepPurple } from '@mui/material/colors';
import { Box, Card, Grid, Stack, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

export const GenerateAssignmentDetailFunctions = () => {
  const theme = useTheme();
  const deepPurpleColor = deepPurple.A200;

  const smDown = useResponsive('down', 'sm');
  const mdDown = useResponsive('down', 'md');
  const padding = () => {
    if (smDown) {
      return 2;
    }
    return 3;
  };
  return (
    <>
      <Stack my={5}>
        <Typography
          fontFamily='"Shantell Sans Light", sans-serif'
          sx={{ color: deepPurpleColor, mb: 1 }}
          fontSize={18}
          align="center"
        >
          Kiểu mới với CenterUp
        </Typography>
        <Typography variant="h2" align="center">
          Tạo và quản lý câu hỏi dễ dàng
        </Typography>
      </Stack>
      <Grid container maxWidth={1240} justifySelf="center" spacing={4}>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.94' : '',
              background: theme.palette.background.neutral,
              position: 'relative',
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Đa dạng loại câu hỏi</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Tạo các dạng câu hỏi khác nhau: Một đáp án đúng - nhiều đáp án đúng - kéo thả -
                  điền chỗ trống - nối đáp án - upload file - tự luận...
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg4"
                  src="/assets/sub-pages/gradient4.png"
                  zIndex={1}
                  bottom={0}
                  left={30}
                  width="95%"
                  height={smDown ? '70%' : '88%'}
                  position="absolute"
                  sx={{ opacity: 0.2 }}
                />
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="employee-detail"
                  src="/assets/sub-pages/lms/generate-assignment/question-type.png"
                  zIndex={2}
                  width={0.95}
                  mb={2}
                  alignSelf="center"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.94' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                {' '}
                <Typography variant="h5">Tạo nhanh câu hỏi với AI (Beta)</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Nhập chủ đề hoặc nội dung, hệ thống AI sẽ gợi ý câu hỏi, đáp án và giải thích.
                  Tiết kiệm thời gian biên soạn, phù hợp cả khi luyện tập lẫn tạo đề thi.
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg8"
                  src="/assets/sub-pages/gradient8.png"
                  zIndex={1}
                  top={smDown ? 30 : -15}
                  left={-20}
                  height="95%"
                  position="absolute"
                  sx={{ opacity: 0.3 }}
                />
                <Box
                  component="img"
                  alt="gradientbg9"
                  src="/assets/sub-pages/gradient9.png"
                  zIndex={1}
                  position="absolute"
                  top={smDown ? 30 : -15}
                  height="90%"
                  right={-100}
                  sx={{ opacity: 0.3 }}
                />
              </Stack>
              <Stack>
                <Box
                  alignSelf="center"
                  alt="class-dashboard"
                  component="img"
                  width={0.95}
                  mb={2}
                  src="/assets/sub-pages/lms/generate-assignment/quick-generate.png"
                  zIndex={2}
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.94' : '',
              background: theme.palette.background.neutral,
              position: 'relative',
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Đính kèm file & media</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Thêm hình ảnh, audio, video hoặc tài liệu minh họa trực tiếp vào câu hỏi. Giúp bài
                  tập sinh động, phù hợp với kỹ năng nghe – nói và các chủ đề trực quan.
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg4"
                  src="/assets/sub-pages/gradient4.png"
                  zIndex={1}
                  bottom={0}
                  left={30}
                  width="95%"
                  height={smDown ? '70%' : '88%'}
                  position="absolute"
                  sx={{ opacity: 0.2 }}
                />
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="employee-detail"
                  src="/assets/sub-pages/lms/generate-assignment/file.png"
                  zIndex={2}
                  width={0.95}
                  mb={2}
                  alignSelf="center"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.94' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                {' '}
                <Typography variant="h5">Gợi ý và giải thích đáp án</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Thiết lập đáp án đúng để chấm điểm tự động. Thêm giải thích hoặc gợi ý sau khi học
                  sinh làm bài giúp học sinh hiểu sâu.
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg8"
                  src="/assets/sub-pages/gradient8.png"
                  zIndex={1}
                  top={smDown ? 30 : -15}
                  left={-20}
                  height="95%"
                  position="absolute"
                  sx={{ opacity: 0.3 }}
                />
                <Box
                  component="img"
                  alt="gradientbg9"
                  src="/assets/sub-pages/gradient9.png"
                  zIndex={1}
                  position="absolute"
                  top={smDown ? 30 : -15}
                  height="90%"
                  right={-100}
                  sx={{ opacity: 0.3 }}
                />
              </Stack>
              <Stack>
                <Box
                  alignSelf="center"
                  alt="class-dashboard"
                  component="img"
                  width={0.95}
                  mb={2}
                  src="/assets/sub-pages/lms/generate-assignment/hint-answer.png"
                  zIndex={2}
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.95' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Gắn tag và phân loại câu hỏi</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Phân loại câu hỏi theo loại câu hỏi, độ khó. Gắn thẻ tag câu hỏi tùy chỉnh theo
                  chủ đề, trình độ, giáo trình…
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  src="/assets/sub-pages/gradient10.png"
                  alt="gradientbg10"
                  zIndex={1}
                  bottom={-50}
                  left={-20}
                  height="92%"
                  position="absolute"
                  sx={{ opacity: 0.2 }}
                />
                <Box
                  component="img"
                  alt="gradientbg11"
                  src="/assets/sub-pages/gradient11.png"
                  zIndex={1}
                  position="absolute"
                  bottom={-40}
                  height="88%"
                  right={-100}
                  sx={{ opacity: 0.2 }}
                />
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="class-task"
                  src="/assets/sub-pages/lms/generate-assignment/tag.png"
                  zIndex={2}
                  width={0.95}
                  mb={2}
                  alignSelf="center"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.95' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                {' '}
                <Typography variant="h5">Bảng danh sách quản lý câu hỏi</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Danh sách câu hỏi rõ ràng, bộ lọc linh hoạt theo loại câu hỏi - độ khó - thẻ tag.
                  Tìm kiếm nhanh theo từ khóa.
                </Typography>
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg8"
                  src="/assets/sub-pages/gradient8.png"
                  zIndex={1}
                  bottom={0}
                  left={-20}
                  height="95%"
                  position="absolute"
                  sx={{ opacity: 0.3 }}
                />
                <Box
                  component="img"
                  alt="gradientbg9"
                  src="/assets/sub-pages/gradient9.png"
                  zIndex={1}
                  position="absolute"
                  bottom={0}
                  height="90%"
                  right={-100}
                  sx={{ opacity: 0.3 }}
                />
              </Stack>
              <Stack>
                <Box
                  component="img"
                  alt="class-schedule"
                  src="/assets/sub-pages/lms/generate-assignment/list-question.png"
                  zIndex={2}
                  width={0.95}
                  mb={2}
                  alignSelf="center"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.9' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Lưu trữ vào thư viện riêng và tái sử dụng</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Tự tạo và quản lý ngân hàng câu hỏi riêng của Trung tâm bạn, bảo mật và phục vụ
                  tái sử dụng cho từng bài tập, chương trình học hoặc từng lớp hợp.
                </Typography>
              </Stack>{' '}
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg8"
                  src="/assets/sub-pages/gradient8.png"
                  zIndex={1}
                  bottom={0}
                  left={-20}
                  height="95%"
                  position="absolute"
                  sx={{ opacity: 0.3 }}
                />
                <Box
                  component="img"
                  alt="gradientbg9"
                  src="/assets/sub-pages/gradient9.png"
                  zIndex={1}
                  position="absolute"
                  bottom={0}
                  height="90%"
                  right={-100}
                  sx={{ opacity: 0.3 }}
                />
              </Stack>
              <Stack width="100%">
                <Box
                  alt="class-assignment"
                  component="img"
                  src="/assets/sub-pages/lms/generate-assignment/assignment-bank.png"
                  zIndex={2}
                  width="100%"
                  alignSelf="center"
                />
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid md={6} sm={12} item>
          <Card
            sx={{
              maxWidth: 820,
              width: '100%',
              justifySelf: 'center',
              aspectRatio: !mdDown ? '1 / 0.9' : '',
              background: theme.palette.background.neutral,
            }}
            variant="outlined"
          >
            <Stack justifyContent="space-between" height="100%">
              <Stack p={padding} zIndex={2}>
                <Typography variant="h5">Ngân hàng bài tập chuẩn hóa của CenterUp</Typography>
                <Typography variant="subtitle2" fontWeight={400}>
                  Sử dụng ngân hàng câu hỏi, bài tập & đề thi đã chuẩn hóa của CenterUp, được xây
                  dựng dựa trên các bộ giáo trình uy tín từ các nhà xuất bản nổi tiếng.
                </Typography>
              </Stack>{' '}
              <Stack>
                <Box
                  component="img"
                  alt="gradientbg12"
                  src="/assets/sub-pages/gradient12.png"
                  zIndex={1}
                  top={0}
                  left={-20}
                  height="95%"
                  position="absolute"
                  sx={{ opacity: 0.6 }}
                />

                <Stack width="100%" mb={mdDown ? 2 : 0}>
                  <Box
                    alt="teacher-wordsheet"
                    component="img"
                    src="/assets/sub-pages/lms/generate-assignment/books.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};
